import { Card, CardContent, Typography, Skeleton, Box } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { WebhookEventDistribution } from '../../../../types/admin';

interface WebhookEventDistributionChartProps {
  data: WebhookEventDistribution[];
  loading?: boolean;
}

export default function WebhookEventDistributionChart({ data, loading }: WebhookEventDistributionChartProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Event Distribution
          </Typography>
          <Skeleton variant="rectangular" height={300} />
        </CardContent>
      </Card>
    );
  }

  const chartData = data.map((item) => ({
    eventType: item.event_type.replace('subscription.', '').replace('payment.', ''),
    count: item.count,
    successRate: item.success_rate,
  }));

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Event Distribution
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Webhook events by type
        </Typography>

        <BarChart
          dataset={chartData}
          xAxis={[
            {
              scaleType: 'band',
              dataKey: 'eventType',
              label: 'Event Type',
            },
          ]}
          series={[
            {
              dataKey: 'count',
              label: 'Event Count',
              color: '#1976d2',
            },
          ]}
          height={300}
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'top', horizontal: 'middle' },
              padding: 0,
            },
          }}
        />

        <Box sx={{ mt: 2 }}>
          {data.map((item) => (
            <Box
              key={item.event_type}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography variant="body2">{item.event_type}</Typography>
              <Typography variant="body2" color={item.success_rate >= 95 ? 'success.main' : 'warning.main'}>
                {item.success_rate}% success
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
